/**
 * Timezone Globalization Utilities — "Empactivo Time Zone" standardı
 *
 * Karar: Backend UTC konuşur, Frontend yerel konuşur.
 *  - toUTC   → Backend'e göndermeden önce local Date'i UTC ISO string'e çevirir ('Z' ile biter).
 *  - fromUTC → Backend'den gelen UTC tarih string'ini local Date nesnesine çevirir.
 *
 * Bağımsız dosya — doğrudan kopyalanabilir, harici bağımlılığı yoktur.
 */

/** Local Date → UTC ISO string. Backend'e giden HER tarih buradan geçmeli. */
export const toUTC = (date: Date): string => {
  return date.toISOString()
}

/** Backend UTC string → Local Date. Karşılaştırma/hesaplama/sıralama yapılan yerde kullan. */
export const fromUTC = (utcDateString: string): Date => {
  // Naive datetime ise (offset/Z yok) UTC kabul et, sonuna 'Z' ekle
  if (
    !utcDateString.endsWith('Z') &&
    !utcDateString.includes('+') &&
    !/\d{2}:\d{2}$/.test(utcDateString.slice(-5))
  ) {
    return new Date(utcDateString + 'Z')
  }
  return new Date(utcDateString)
}
